<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">结算总表</div>
      
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">所属运营商</div>
            <div class="query-inputs-div flex-1">
              <el-select
                v-model="queryInfo.dealerId"
                class="full-width"
                clearable
                filterable
                placeholder="请选择运营商名称"
                size="small"
                @change="changeDealNo"
              >
                <el-option
                  v-for="item in dealerArr"
                  :key="item.id"
                  :label="item.dealName"
                  :value="item.id"
                />
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">结算商户</div>
            <div class="query-inputs-div flex-1">
              <el-select
                v-model="queryInfo.receiveAccountId"
                class="full-width"
                clearable
                filterable
                placeholder="请选择结算商户"
                size="small"
                @change="changeBusiness"
              >
                <el-option
                  v-for="item in clearBusinessArr"
                  :key="item.receiveAccountId"
                  :label="item.accountName"
                  :value="item.receiveAccountId"
                />
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">结算站点</div>
            <div class="query-inputs-div flex-1">
              <el-select
                v-model="queryInfo.stationNo"
                class="full-width"
                clearable
                filterable
                placeholder="请选择结算站点"
                size="small"
                @change="changeStation"
              >
                <el-option
                  v-for="item in clearStationSrr"
                  :key="item.stationNo"
                  :label="item.stationName"
                  :value="item.stationNo"
                />
              </el-select>
            </div>
          </div>
        </template>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">结算范围</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                v-model="searchTime"
                :picker-options="pickerOptions"
                end-placeholder="结束日期"
                range-separator="-"
                size="small"
                start-placeholder="开始日期"
                style="width: 100%"
                type="daterange"
                value-format="yyyy-MM-DD"
                @change="handleDateChange"
              />
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">结算状态</div>
            <div class="query-inputs-div flex-1">
              <el-select
                v-model="queryInfo.payOutStatus"
                class="full-width"
                clearable
                filterable
                placeholder="请选择清分账户类型"
                size="small"
              >
                <el-option label="待上传发票" value="NOT_UPDATE_INVOICE"/>
                <el-option label="待审核(已上传发票)" value="VERIFYING"/>
                <el-option label="审核未通过" value="VERIFY_FAIL"/>
                <el-option label="结算完成" value="FINISH"/>
              </el-select>
            </div>
          </div>
        </template>
        <template slot="actions">
          <button
            class="common-bg-button"
            @click="getListData(pagination, true)"
          >
            搜 索
          </button>
          <button class="common-empty-button" @click="reset()">重 置</button>
        </template>
      </ZD-list-querys>
      
      <div class="search-list-info">
        <div class="list-info-div">
          <div>商户名称：{{ stationList.accountName || '-' }}</div>
          <div>结算站点：{{ stationList.stationName || '-' }}</div>
          <div>联系人：{{ "-" }}</div>
          <div>联系电话：{{ "-" }}</div>
          <div>合同有效期：{{ stationList.expirationTime || '-' }}</div>
          <div>分成周期：{{ stationList.dividedCyclesName || '-' }}</div>
          <div>提现周期：{{ stationList.payoutCyclesName || '-' }}</div>
          <div>分成方式：{{ stationList.splitTypeName || '-' }}</div>
          <div>
            分成比例：{{ stationList.splitTypeValueString || "-" }}
            <!-- {{ stationList.splitType === 'AMOUNT' ? ' % ' : ' 元 ' }}-->
          </div>
        </div>
        <div v-for="(item, index) in sumList" :key="index" class="list-info-pgh">
          <span v-if="item.settlementStatus === 'SETTLEMENT_SUCCESS'">可结算订单：</span>
          <span v-if="item.settlementStatus === 'DIVIDED_SUCCESS'">已分待提现：</span>
          <span v-if="item.settlementStatus === 'NOT_DIVIDED'">待分成订单：</span>
          <span v-if="item.settlementStatus === 'IN_SETTLEMENT'">结算中订单：</span>
          {{ item.startTime }} ~ {{ item.endTime }} 订单:
          {{ item.orderCount }} 笔：结算金额（元）：{{ item.actPayFee }} 元 * 分成比例：
          {{ stationList.splitTypeValueString }}
          <!-- {{ stationList.splitType === 'AMOUNT' ? ' % ' : ' 元 ' }}-->
          = 分成费用（元）： {{ item.orderTotalSplitAmount }}
          <el-button class="common-empty-button" plain size="mini" @click="handelAboutOrder(item, '01')">
            查看订单
          </el-button>
          <el-button v-if="item.settlementStatus === 'IN_SETTLEMENT'" type="primary" plain size="mini" @click="handleInvoiceSubmit(item)">
            提交发票结算
          </el-button>
        </div>
        <!--
        <div class="list-info-pgh">
          已分待体现： {{ "-" }} ~ {{ "-" }} 订单
          {{ "-" }} 笔：结算金额（元）：{{ "-" }} 元 * 分成比例：
          {{ stationList.amountSplitPercent }}
          {{ stationList.splitType === 'AMOUNT' ? ' % ' : ' 元 ' }}
          = 分成费用（元）： {{ "-" }}
          <el-button class="common-empty-button" plain size="mini">
            查看订单
          </el-button>
        </div>
        <div class="list-info-pgh">
          可结算订单： {{ "-" }} ~ {{ "-" }} 订单
          {{ "-" }} 笔：结算金额（元）：{{ "-" }} 元 * 分成比例：
          {{ stationList.amountSplitPercent }}
          {{ stationList.splitType === 'AMOUNT' ? ' % ' : ' 元 ' }}
          = 分成费用（元）： {{ "-" }}
          <el-button class="common-empty-button" plain size="mini">
            查看订单
          </el-button>
        </div>
        -->
      </div>
      
      <!-- 表格 -->
      <div class="list-table">
        <el-table
          :data="tableData"
          :header-cell-style="pageConfig.tableConfig.herderStyle"
          border stripe style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"/>
          <el-table-column label="结算单号" min-width="320" prop="id"/>
          <el-table-column label="开始日期" min-width="160" prop="createdWhen"/>
          <el-table-column label="订单数量" min-width="160" prop="orderCount"/>
          <el-table-column label="预付金额（元）" min-width="160" prop="prePayFee"/>
          <el-table-column label="订单金额（元）" min-width="160" prop="createdWhen"/>
          <el-table-column label="订单电费（元）" min-width="160" prop="elecFee"/>
          <el-table-column label="订单服务费（元）" min-width="160" prop="receivableServFee"/>
          <el-table-column label="结算金额（元）" min-width="160" prop="settleFee"/>
          <el-table-column label="结算电费（元）" min-width="160" prop="actElecFee"/>
          <el-table-column label="结算服务费（元）" min-width="160" prop="servFee"/>
          <el-table-column label="在线支付（元）" min-width="160" prop="actPayFee"/>
          <el-table-column label="钱包余额支付（元）" min-width="160" prop="deductionFee"/>
          <el-table-column label="度电支付（度）" min-width="160" prop="deductionElec"/>
          <el-table-column label="减免电费" min-width="160" prop="reduceElecFee"/>
          <el-table-column label="减免服务费" min-width="160" prop="reduceServFee"/>
          <el-table-column label="退款金额" min-width="160" prop="refundAmount"/>
          <el-table-column label="分成方式" min-width="160" prop="splitTypeName"/>
          <el-table-column label="分成比例" min-width="160" prop="splitTypeValueString"/>
          <el-table-column label="分成费用" min-width="160" prop="payoutAmount"/>
          <el-table-column label="开票金额" min-width="160" prop="createdWhen"/>
          <el-table-column label="开票税费" min-width="160" prop="payoutRecordNo"/>
          <el-table-column label="交易费" min-width="160" prop="createdWhen"/>
          <el-table-column label="结算状态" min-width="240" prop="payOutStatusName">
            <template slot-scope="scope">
              <div style="width: 100%; display: flex; flex-direction: column; align-items: center;">
                <div>{{ scope.row.payOutStatusName }}</div>
                <div style="margin-top: 10px">
                  <el-button class="table-btn" plain size="mini"
                             type="primary"
                             :disabled="!scope.row.payoutInvoiceFileId"
                             @click.stop="handleInvoiceSettlement(scope.row, 'image')">
                    查看发票
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" fixed="right" label="操作" width="240">
            <template slot-scope="scope">
              <div class="operate-group">
                <div class="item">
                  <el-button class="table-btn" plain size="mini" type="primary"
                             @click.stop="handelAboutOrder(scope.row, '02')">
                    相关订单
                  </el-button>
                  <el-button v-if="scope.row.payOutStatus === 'NOT_UPDATE_INVOICE' || scope.row.payOutStatus === 'VERIFY_FAIL'"
                             class="table-btn" plain size="mini" type="primary"
                             @click.stop="handleInvoiceSettlement(scope.row, 'info')">
                    发票上传
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"/>
      </div>
      
      <!-- 提交发票 -->
      <el-dialog
        :visible.sync="dialogVisible"
        :title="examineType === 'info' ? '上传发票' : examineType === 'image' ? '发票详情' : ''"
        top="8vh"
        width="32%"
        @close="resetForm"
      >
        <div v-if="examineType === 'image'"
             style="width: 100%; height: 420px; display: flex; align-items: center; justify-content: center; overflow: hidden; cursor: pointer"
             @click="window.open(imgPath)">
          <img :src="imgPath" alt="" style="width: 100%"/>
        </div>

        <div  v-if="examineType === 'info'" class="edit-form">
          <!-- 数据填写 -->
          <el-form
            ref="ruleForm"
            :model="popInfo"
            label-position="top"
          >
            <el-form-item label="分成金额：" size="small" style="width: 100%">
              <div style="width: 100%;display: flex;flex-direction: column">
                <el-input v-model="popInfo.payoutAmount" disabled />
                <div style="color: red; margin-top: 8px">
                  请上传同等金额的增值税电子发票
                </div>
              </div>
            </el-form-item>
            <el-form-item label="发票抬头：" size="small" style="width: 100%">
              <el-input v-model="popInfo.title" disabled />
            </el-form-item>
            <el-form-item label="发票内容：" size="small" style="width: 100%">
              <el-input v-model="popInfo.content" disabled />
            </el-form-item>
            <el-form-item label="发票上传：" size="small" style="width: 100%">
              <el-upload
                :file-list="fileList"
                :http-request="toUploadcontractFile"
                :on-remove="handleRemove"
                action="#"
                class="upload-demo"
                accept="image/png, image/jpeg, image/jpg"
                multiple
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
              </el-upload>
            </el-form-item>
            <el-form-item style="width: 100%">
              <el-button type="primary" size="small" @click="submitForm('ruleForm')">
                提 交
              </el-button>
              <el-button size="small" @click="resetForm('ruleForm')">
                取 消
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      
    </div>
  </div>
</template>

<script>
  import pageConfig from "./page-config";
  
  export default {
    data() {
      return {
        pageConfig: pageConfig, // 页面配置
        tableData: [], // 表格数据
        selections: [], // 表格选项
        pagination: pageConfig.pagination,
        
        dealerArr: [], // 所属运营商
        clearBusinessArr: [], // 相关结算商户
        clearStationSrr: [], // 结算站点
        businessList: {}, // 商户信息集合
        stationList: {}, // 站点信息集合
        sumList: [], // 统计信息集合
        
        queryInfo: {
          dealerId: '',
          receiveAccountId: '',
          stationNo: '',
          settlementStatus: '',
          payOutStatus: '',
        },
        searchTime: [], //选择时间
        pickerOptions: {
          //修改el-date-picker的时间
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },

        // 提交发票结算
        invoiceInfo: {
          stationNo: '',
          receiveAccountId: '',
        },
        
        // 发票上传
        dialogVisible: false,
        popInfo: {
          title: '上海挚达新能源公共配套有限公司',
          content: '充电服务',
          id: '',
          payoutAmount: '',
          payoutInvoiceName: '',
          payoutInvoiceFileId: '',
        },
        fileList: [],
        examineType: '',
        imgPath: '',
      };
    },
    methods: {
      init() {
        this.getListData(this.pagination, true);
        this.getDealer();
      },
      // 获取表格数据
      getListData(pagination, reload = false) {
        let _ = this;
        _.$U.showLoading(_);
        _.queryInfo.pageNum = pagination.current - 1;
        if (reload) {
          this.pagination.current = 1;
          _.queryInfo.pageNum = 0;
        }
        _.queryInfo.pageSize = pagination.pageSize;
        _.queryInfo.corpNo = _.$store.state.corpNo;
        _.$H.post(_, _.$A.cleanSettleRecord.list, _.queryInfo).then((res) => {
          _.tableData = res.data.data.content || [];
          _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_);
        });
      },
      // 所属运营商
      getDealer() {
        let _ = this;
        _.$H.post(_, _.$A.dealer.allList, {}).then((res) => {
          _.dealerArr = res.data.data || [];
        });
      },
      
      // 根据运营商查询 相关结算商户
      changeDealNo(val) {
        let _ = this;
        if (val) {
          const list = _.dealerArr.find(item => item.id === val);
          if (list) {
            _.$H.get(_, _.$A.cleanSettleRecord.getOptions + list.id).then((res) => {
              _.clearBusinessArr = res.data.data || [];
            })
          }
        }
      },
      // 根据选择结算商户 查询 结算站点
      changeBusiness(val) {
        let _ = this;
        if (val) {
          _.businessList = _.clearBusinessArr.find(item => item.receiveAccountId === val);
          _.clearStationSrr = _.businessList.stationList || [];
          _.queryInfo.receiveAccountId = _.businessList.receiveAccountId || '';
        }
      },
      // 选择结算站点 - 查询 统计信息
      changeStation(val) {
        let _ = this;
        if (val) {
          _.stationList = _.clearStationSrr.find(item => item.stationNo === val);
          _.queryInfo.stationNo = _.stationList.stationNo || '';
          const params = {
            stationNo: _.queryInfo.stationNo,
            receiveAccountId: _.queryInfo.receiveAccountId
          }
          // 提交发票审核使用
          _.invoiceInfo = params;

          _.$H.post(_, _.$A.cleanSettleRecord.sumInfo, params).then((res) => {
            _.sumList = res.data.data || [];
          })
        }
      },

      // 提交发票结算
      handleInvoiceSubmit(row) {
        let _ = this;
        _.$U.showLoading(_);
        _.$H.post(_, _.$A.cleanSettleRecord.submitSettle, _.invoiceInfo).then((res) => {
          if(res.data.status === 200) {
            _.$U.hideLoading(_);
            _.$U.success('提交成功');

            _.getListData(_.pagination, true);
          }
        })
      },

      // 上传发票、发票查看
      handleInvoiceSettlement (row, type) {
        let _ = this;
        _.examineType = type;

        if(type === 'image') {
          _.$H.post(_, `${_.$A.cleanSettleRecord.imgInvoicePath}?fileId=${row.payoutInvoiceFileId}`).then((res) => {
            _.imgPath = res.data.data || '';
            if (!res.data.data) {
              return _.$U.error('获取发票失败！')
            }
            _.dialogVisible = true;
          })
        }

        if(type === 'info') {
          _.popInfo.id = row.id;
          _.popInfo.payoutAmount = row.payoutAmount;
          _.dialogVisible = true;
        }

      },
      // 上传发票附件
      toUploadcontractFile(param) {
        let _ = this;

        const isJPG = ['image/jpeg', 'image/jpg', 'image/png'].includes(param.file.type);
        if(!isJPG){
          _.fileList =[]
          return _.$message.error('上传logo图片只能是 jpg / png 格式!');
        }

        // 文件大小限制
        const isLt2M = param.file.size / 1024 / 1024 < 500;
        if (!isLt2M) {
          _.fileList =[]
          return _.$message.error("上传文件大小不能超过 500MB!");
        }

        if (param) {
          let formData = new FormData();
          formData.append("filePath", 'clearflow/invoice/');
          formData.append("file", param.file);
          _.$H.post(_, _.$A.cleanSettleRecord.uploadInvoice, formData).then((res) => {
            _.popInfo.payoutInvoiceName = res.data.data.sourceName;
            _.popInfo.payoutInvoiceFileId = res.data.data.fileId;
            _.$U.success('上传成功！')
          });
        }
      },
      handleRemove() {
        let _ = this;
        _.popInfo.payoutInvoiceName = '';
        _.popInfo.payoutInvoiceFileId = '';
        _.fileList = [];
      },
      // 提交发票结算 - 提交
      submitForm() {
        let _ = this;

        const params = {
          id: _.popInfo.id,
          payoutInvoiceName: _.popInfo.payoutInvoiceName || '',
          payoutInvoiceFileId: _.popInfo.payoutInvoiceFileId || '',
        }

        if(!params.payoutInvoiceName && !params.payoutInvoiceFileId) {
          return _.$U.error('请上传发票！');
        }

        _.$H.post(_, _.$A.cleanSettleRecord.submitInvoice, params).then((res) => {
          _.$U.success('发票上传保存成功！')
        })
      },
      
      // 提交发票结算 - 关闭弹窗
      resetForm(formName) {
        let _ = this;
        if (formName) {
          _.$refs[formName].resetFields();
        }
        _.dialogVisible = false;
      },
      
      // 复选框
      handleSelectionChange(e) {
        this.selections = e;
      },

      // 相关订单
      handelAboutOrder(row, type) {
        let _ = this;
        let params = {};
        let list = {};
        // 筛选条件 筛选出来的 查询详情所需数据
        if (type === '01') {
          list = {
            dealerId: _.queryInfo.dealerId,
            receiveAccountId: _.queryInfo.receiveAccountId,
            stationNo: _.queryInfo.stationNo,
            settlementStatus: row.settlementStatus,
            startTime: row.startTime,
            endTime: row.endTime,
          }

          params = {
            stationNo: _.queryInfo.stationNo,
            receiveAccountId: _.queryInfo.receiveAccountId,
          }
        }

        // 表格中查询详情所需数据
        if (type === '02') {
          params = {
            payoutRecordId: row.id,
          }
        }

        // 筛选条件
        _.$store.commit('setSearchList', list);
        // 查询详情
        _.$store.commit('setSearchParams', params)

        _.$router.push({
          path: "summaryDetail"
        });
      },
      
      //选择结束时间
      handleDateChange(val) {
        if (val) {
          this.queryInfo.dtFrom = val[0];
          this.queryInfo.dtTo = val[1];
        } else {
          delete this.queryInfo.dtFrom;
          delete this.queryInfo.dtTo;
        }
      },
      
      // 页面新增方法
      listAddFun() {
        let _ = this;
        _.$S.listAddFun(_, pageConfig.tableEditObj);
      },
      
      // 页面编辑方法
      listEditFun() {
        let _ = this;
        _.$S.tableEditFun(_, _.selections, pageConfig.tableEditObj);
      },
      
      //重置
      reset() {
        this.pagination.current = 1;
        delete this.queryInfo.dealerId;
        delete this.queryInfo.dealName;
        delete this.queryInfo.dtFrom;
        delete this.queryInfo.dtTo;
        delete this.queryInfo.receiveAccountId;
        delete this.queryInfo.stationNo;
        delete this.queryInfo.settlementStatus;
        this.searchTime = [];
        this.getListData(this.pagination, true);
      },
    },
    mounted() {
      this.init();
    },
  };
</script>

<style lang="less" scoped>
  .margin-tb {
    height: 32px;
    margin-top: 4px;
  }
  
  .search-list-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px 20px 4px 20px;
    box-sizing: border-box;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 20px;
    
    .list-info-div {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      
      div {
        width: calc(100% / 3);
        margin-bottom: 16px;
        font-size: 14px;
      }
    }
    
    .list-info-pgh {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      
      .common-empty-button {
        margin-left: 20px;
      }
    }
  }
</style>
